var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/badge.css';
let Badge = class Badge extends LitElement {
    constructor() {
        super(...arguments);
        this.text = this.innerText;
        this.type = 'secondary';
        this.version = 'contained';
        this.href = '';
        this.target = '_self';
    }
    static get styles() {
        if (env.debug) {
            return css `
        `;
        }
        return [style];
    }
    clickRedirect() {
        if (this.href) {
            window.open(this.href, this.target);
        }
    }
    render() {
        var cursor_style = '';
        if (this.href) {
            cursor_style = 'pointer';
        }
        return html `
      ${env.debug ? html `<link rel="stylesheet" href="/css/badge.css" />` : html ``}
      
      ${this.version == "rounded" ? html `<div class="badge badge-contained rounded-pill badge-${this.type}" @click="${this.clickRedirect}" style="cursor: ${cursor_style}">${this.text}</div>` : html `
       <div class="badge badge-${this.version} badge-${this.type}" @click="${this.clickRedirect}" style="cursor: ${cursor_style}">${this.text}</div>
      `}
    `;
    }
};
__decorate([
    property()
], Badge.prototype, "text", void 0);
__decorate([
    property()
], Badge.prototype, "type", void 0);
__decorate([
    property()
], Badge.prototype, "version", void 0);
__decorate([
    property()
], Badge.prototype, "href", void 0);
__decorate([
    property()
], Badge.prototype, "target", void 0);
Badge = __decorate([
    customElement('gs1-badge')
], Badge);
export { Badge };
//# sourceMappingURL=badge.js.map